const _ = require('lodash');

module.exports = function () {
    return {
        restrict: 'A',
        scope: false,
        controller: [
            '$element', '$attrs', function ($element, $attrs) {
                this.$onInit = function() {
                    const features = {
                        menubar: $attrs.windowMenubar || 'no',
                        toolbar: $attrs.windowToolbar || 'no',
                        resizable: $attrs.windowResizable || 'yes',
                        scrollbars: $attrs.windowScrollbars || 'yes',
                        height: $attrs.windowHeight || 420,
                        width: $attrs.windowWidth || 550
                    };
                    const featureString = _.map(features, function (value, feature) {
                        return feature + '=' + value;
                    }).join(',');

                    $element.on('click', function (e) {
                        e.preventDefault();

                        window.open($attrs.href, $attrs.windowTitle, featureString);
                    });
                };
            }
        ]
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/openwindow/open-window-directive.js
 **/